var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      class: _vm.$.compare_dropdown,
      style: _vm.disabled ? { opacity: ".5", pointerEvents: "none" } : null,
    },
    [
      _c("div", { class: _vm.$.wrapper }, [
        _c(
          "div",
          {
            ref: "button",
            class: [_vm.$.button, _vm.showMenu ? _vm.$.active : ""],
            on: { click: _vm.toggle },
          },
          [
            _c("div", { class: _vm.$.label }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.locales("reports_pages_model_of_calc")) +
                  ":\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.$.name }, [
              _vm._v("\n        " + _vm._s(_vm.label) + "\n      "),
            ]),
            _vm._v(" "),
            _c("svg-sprite", {
              class: _vm.$.icon,
              attrs: {
                name: _vm.showMenu ? "arrow-top" : "arrow-down",
                colo: "",
                type: "bold",
                size: 20,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.$select.select, _vm.$select.reports_toolbar] },
        [
          _vm.showMenu
            ? _c("context-menu", {
                staticStyle: { "min-width": "215px" },
                attrs: { position: _vm.positionMenu },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _vm._l(_vm.menu, function (item, index) {
                            return [
                              item.group
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      class: _vm.$select.group_title,
                                    },
                                    [
                                      _c("div", { class: _vm.$select.text }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.group) +
                                            "\n            "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { class: _vm.$select.line }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "item"
                                ? _c(
                                    "div",
                                    { key: index },
                                    [
                                      item.tooltip
                                        ? _c("tooltip", {
                                            class: _vm.$select.tooltip,
                                            attrs: {
                                              content: item.tooltip.content,
                                              position: item.tooltip.position,
                                              "with-animation": false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "body",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            _vm.$select
                                                              .menu_item,
                                                            item.isActive
                                                              ? _vm.$select
                                                                  .active
                                                              : "",
                                                            item.isDisabled
                                                              ? _vm.$select
                                                                  .disabled
                                                              : "",
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onSelect(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              class:
                                                                _vm.$select
                                                                  .text,
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    item.text
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  _vm.$select.menu_item,
                                                  item.isActive
                                                    ? _vm.$select.active
                                                    : "",
                                                  item.isDisabled
                                                    ? _vm.$select.disabled
                                                    : "",
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onSelect(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { class: _vm.$select.text },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.text) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "submenu"
                                ? _c(
                                    "div",
                                    { key: index },
                                    [
                                      item.tooltip
                                        ? _c("tooltip", {
                                            class: _vm.$select.tooltip,
                                            attrs: {
                                              content: item.tooltip.content,
                                              position: item.tooltip.position,
                                              "with-animation": false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "body",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            _vm.$select
                                                              .menu_item,
                                                            _vm.$select
                                                              .item_level,
                                                            item.isActive
                                                              ? _vm.$select
                                                                  .active
                                                              : "",
                                                            item.isDisabled
                                                              ? _vm.$select
                                                                  .disabled
                                                              : "",
                                                          ],
                                                          on: {
                                                            mouseenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.enterSelect(
                                                                  item.name,
                                                                  $event.target
                                                                )
                                                              },
                                                            mouseleave:
                                                              _vm.leaveSelect,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              class:
                                                                _vm.$select
                                                                  .text,
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    item.text
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("svg-sprite", {
                                                            class:
                                                              _vm.$select.icon,
                                                            style: {
                                                              "margin-right": 0,
                                                              "margin-left":
                                                                "auto",
                                                              color: "#b2b2b2",
                                                            },
                                                            attrs: {
                                                              name: "drop-right",
                                                              type: "bold",
                                                              size: "24",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _vm.showSubmenuName ===
                                                            item.name &&
                                                          item.list.length
                                                            ? _c(
                                                                "context-menu",
                                                                {
                                                                  staticClass:
                                                                    "gantt_scroll",
                                                                  style: {
                                                                    "max-height":
                                                                      "270px",
                                                                    "min-width":
                                                                      "215px",
                                                                    "border-top-left-radius": 0,
                                                                    "border-bottom-left-radius": 0,
                                                                  },
                                                                  attrs: {
                                                                    position:
                                                                      _vm.positionSubmenu,
                                                                    side: "right",
                                                                    offset: {
                                                                      top: -8,
                                                                    },
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "body",
                                                                          fn: function () {
                                                                            return _vm._l(
                                                                              item.list,
                                                                              function (
                                                                                subitem,
                                                                                index2
                                                                              ) {
                                                                                return _c(
                                                                                  "div",
                                                                                  {
                                                                                    key: index2,
                                                                                    class:
                                                                                      [
                                                                                        _vm
                                                                                          .$select
                                                                                          .menu_item,
                                                                                        subitem.id ==
                                                                                        item.selectedSubmenuId
                                                                                          ? _vm
                                                                                              .$select
                                                                                              .active
                                                                                          : "",
                                                                                      ],
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.onSelect(
                                                                                            item,
                                                                                            subitem
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        class:
                                                                                          _vm
                                                                                            .$select
                                                                                            .text,
                                                                                        style:
                                                                                          {
                                                                                            width:
                                                                                              "190px",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                          " +
                                                                                            _vm._s(
                                                                                              subitem.name
                                                                                            ) +
                                                                                            "\n                        "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            )
                                                                          },
                                                                          proxy: true,
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  _vm.$select.menu_item,
                                                  _vm.$select.item_level,
                                                  item.isActive
                                                    ? _vm.$select.active
                                                    : "",
                                                  item.isDisabled
                                                    ? _vm.$select.disabled
                                                    : "",
                                                ],
                                                on: {
                                                  mouseenter: function (
                                                    $event
                                                  ) {
                                                    return _vm.enterSelect(
                                                      item.name,
                                                      $event.target
                                                    )
                                                  },
                                                  mouseleave: _vm.leaveSelect,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { class: _vm.$select.text },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.text) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("svg-sprite", {
                                                  class: _vm.$select.icon,
                                                  style: {
                                                    "margin-right": 0,
                                                    "margin-left": "auto",
                                                    color: "#b2b2b2",
                                                  },
                                                  attrs: {
                                                    name: "drop-right",
                                                    type: "bold",
                                                    size: "24",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _vm.showSubmenuName ===
                                                  item.name && item.list.length
                                                  ? _c("context-menu", {
                                                      staticClass:
                                                        "gantt_scroll",
                                                      style: {
                                                        "max-height": "270px",
                                                        "min-width": "215px",
                                                        "border-top-left-radius": 0,
                                                        "border-bottom-left-radius": 0,
                                                      },
                                                      attrs: {
                                                        position:
                                                          _vm.positionSubmenu,
                                                        side: "right",
                                                        offset: { top: -8 },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "body",
                                                            fn: function () {
                                                              return _vm._l(
                                                                item.list,
                                                                function (
                                                                  subitem,
                                                                  index2
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: index2,
                                                                      class: [
                                                                        _vm
                                                                          .$select
                                                                          .menu_item,
                                                                        subitem.id ==
                                                                        item.selectedSubmenuId
                                                                          ? _vm
                                                                              .$select
                                                                              .active
                                                                          : "",
                                                                      ],
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onSelect(
                                                                              item,
                                                                              subitem
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          class:
                                                                            _vm
                                                                              .$select
                                                                              .text,
                                                                          style:
                                                                            {
                                                                              width:
                                                                                "190px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                        " +
                                                                              _vm._s(
                                                                                subitem.name
                                                                              ) +
                                                                              "\n                      "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1216677601
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }